module.exports = __webpack_public_path__ + "static/media/waiting.9e58dcb7.svg";